export const phrases = {
  heading_settings_sort: "Tri de la liste des employés",
  body_settings_sort: "Trier la liste des collaborateurs par prénom ou par nom de famille.",
  since_o_clock: "Depuis {time} heures",
  old_data_warning_my_area: "Nous n'avons pas pu charger de nouvelles informations. Assure-toi d'être connecté à Internet.",
  no_data_warning_my_area: "Assure-toi que tu es connecté à Internet et réessaie.",
  no_data_available_my_area: "Aucune donnée ne peut être chargée",
  last_update_data: "Dernière mise à jour",
  something_went_wrong_absences: "Quelque chose s'est mal passé. Veuillez réessayer ultérieurement.",
  something_went_wrong_with_the_pin_entry: "Quelque chose s'est mal passé avec la saisie du code PIN",
  pin_must_be_four_digits: "Le code PIN doit être composé d'exactement quatre chiffres.",
  pins_do_not_match: "Les codes PIN saisis ne correspondent pas.",
  pin_is_not_numerical: "Le code PIN doit être composé uniquement de chiffres.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Pointage",
  finish_break: "Mettre fin à la pause",
  finish_loading_time: "Terminer le temps de chargement",
  finish_driving_time: "Terminer le temps de trajet",
  finish_business_trip: "Terminer un déplacement",
  finish_project_as_task: "Terminer le projet",
  finish_special_one: "Quitter Sonder1",
  finish_special_two: "Quitter Sonder2",
  you_clockout: "Tu pointes",
  sentence_work_time: "Tu es en train de travailler. | Vous travaillez en ce moment.",
  sentence_break: "Tu es en train de faire une pause. | Vous êtes en pause.",
  sentence_loading_time: "Tu saisis actuellement le temps de chargement. Hâte-toi lentement ! | Vous êtes en train de saisir le temps de chargement. Hauruck !",
  sentence_business_trip: "Connecté à la permanence. Amusez-vous bien !",
  sentence_driving_time: "Tu es en train de réserver du temps de conduite. Attache ta ceinture et c'est parti ! | Vous êtes en train de réserver du temps de trajet. Attachez votre ceinture et partez !",
  sentence_special_one: "Vous êtes en train de réserver Sonder1. | Vous êtes en train de réserver Sonder1.",
  sentence_special_two: "Tu es en train de réserver Sonder2. | Vous êtes en train de réserver Sonder2.",
  sentence_custom_time: "Tu es en train de réserver | Vous êtes en train de réserver",
  you_are_booked_in_activity: "Vous tamponnez {activity}! | Vous tamponnez {activity}!",
  substitute_warning: "Pour les absences à partir de { days } jours, un représentant doit être indiqué.",
  substituted_by: "Représenté par",
  name_clocked_in: "{name} estampillé",
  /************************************/
  //Signature stuff:

  signature: "Signature",
  please_sign: "Veuillez signer",
  signature_with_date: "Signature du {date}",
  signature_with_date_with_name: "Signature du {date} de {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Signature du {date} de {name} à {location}",
  signature_with_name: "Signature de {name}",
  signature_with_name_with_location: "Signature de {name} dans {location}",
  signature_with_location: "Signature dans {location}",
  /*************************************/

  accept_terms_and_conditions: "En envoyant le formulaire, tu acceptes notre {agb} et notre {datenschutzerklaerung}.",
  what_is_your_name: "Quel est ton nom ?",
  your_email: "Ton adresse e-mail",
  what_is_your_company_name: "Quel est le nom de ton entreprise ?",
  what_do_you_want_to_do_with_clockin: "Que veux-tu faire avec clockin ?",
  almost_finished: "On y est presque",
  test_clockin_for_amount_period: "Essaie clockin {amountOfDaysTestPeriod} gratuitement pendant quelques jours !",
  code_needed_to_connect: "Utilise ton code",
  you_have_no_company_code: "Tu n'as pas de code ? Adresse-toi à la personne de contact de ton entreprise.",
  connect_your_device: "Connecte ton appareil !",
  please_type_in_device_id: "Veuillez saisir l'identifiant de l'appareil que vous trouverez sous Appareils mobiles sur notre site web.",
  new_at_clockin: "Nouveau chez clockin ?",
  pin_repeat: "Répéter le code PIN",
  configure_your_pin: "Définis ton code PIN à 4 chiffres",
  configure_your_pin_text: "Tu as besoin du code PIN pour accéder à ton espace personnel sur le terminal tablette.",
  congratulations: "Félicitations !",
  start_now: "Commencer maintenant",
  device_name_info: "Tu peux changer le nom d'appareil de ton appareil mobile afin de garder une vue d'ensemble si tu as plusieurs appareils. Exemple : \"Smartphone MaxMustermann\". Le nom peut aussi être modifié ultérieurement.",
  select_project: "Sélectionner un projet",
  select_time: "Heure choisie",
  create_new_account: "Créer un nouveau compte",
  join_my_company: "Rejoignez mon entreprise",
  join_clockin_with_qr: "Rejoindre avec le code QR",
  change_project: "Changer de projet",
  my_messages: "Mes messages",
  my_documents: "Mes documents",
  my_data_and_passwords: "Mes données & mots de passe",
  my_account_data: "Mes données",
  change_my_password: "Modifier le mot de passe",
  forgot_password: "Je ne connais pas mon mot de passe.",
  open_camera: "Ouvrir la caméra",
  scan_now: "Scanner maintenant",
  sync_now: "Synchroniser maintenant",
  clear_logs: "Vider les logs",
  saveAndGoBack: "Enregistrer et revenir",
  full_day: "Journée complète",
  activate_scanner: "Activation du scanner",
  scanner_is_inactive: "Scanner inactif",
  change_project_by_scan_qr: "Scanne le code QR du projet dans lequel tu souhaites passer.",
  scan_device_by_qr: "Scanne le code QR de l'appareil que tu souhaites utiliser.",
  no_access_to_camera_please_connect_device_manually: "Malheureusement, l'accès à la caméra n'a pas été possible, veuillez saisir le code de l'appareil manuellement.",
  no_access_to_camera_please_clockin_manually: "Malheureusement, l'accès à la caméra n'a pas été possible, merci de pointer manuellement.",
  qr_code_login: "Code QR inscription",
  scan_to_login: "Scanne ton code QR pour t'inscrire.",
  checklist_was_saved: "La liste de contrôle a été enregistrée",
  question_save_changes_short: "Enregistrer les modifications ?",
  question_save_changes: "Tu veux enregistrer les modifications ?",
  question_delete_checklist_short: "Supprimer la liste de contrôle ?",
  question_delete_checklist: "Es-tu sûr de vouloir supprimer la liste de contrôle ?",
  checklist_is_sending: "Une liste de contrôle sera envoyée",
  checklist_sent_successfully: "Liste de contrôle envoyée avec succès 🎉",
  checklist_could_not_be_sent: "La liste de contrôle n’a pas pu être envoyée, veuillez réessayer plus tard.",
  checklist_transmission_problems_in_the_past: "Dans le passé, il y a eu des problèmes de transfert avec certains fichiers.",
  checklist_send_with_potential_data_loss: "Souhaitez-vous essayer d’envoyer la liste de contrôle sans ces fichiers ?",
  documentation_is_sending: "La documentation du projet est envoyée",
  documentation_sent_successfully: "Documentation du projet envoyée avec succès 🎉",
  confirm_documentation_dismissal: "Tu veux vraiment rejeter la documentation ?",
  discard_unsaved_changes: "Voulez-vous abandonner vos changements ?",
  documentation_will_be_sent_when_online: "La documentation sera envoyée dès que tu seras à nouveau en ligne.",
  confirmation_is_sending: "La confirmation de projet est envoyée",
  ask_for_geo_permission: "Cette application a besoin de ta localisation, " + "mais il manque la permission de le faire.\n\n" + "Tu veux ouvrir les paramètres ?",
  all_projects: "Tous les projets",
  half_day: "Demi-journée",
  start_end: "Par heure",
  my_area: "Mon domaine",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin expliqué par Freddi",
  add_time: "Créer du temps",
  show_times_in_confirmation: "Afficher les temps dans la confirmation",
  change_time: "Modifier l'heure",
  finish_project: "Clôturer le projet",
  finish_project_date: "Clôturer le rendez-vous",
  unfinish_project: "Rouvrir le projet",
  unfinish_project_date: "Réouverture du rendez-vous",
  absence_overview: "Gérer les absences",
  edit_absence: "Modifier une absence",
  edited_absence: "Absence traitée",
  created_absence: "Bon d'absence créé avec succès",
  creating_absence: "Ton bon d'absence est maintenant créé",
  error_creating_absence: "Erreur lors de la création du bon d'absence",
  create_absence: "Créer une absence",
  deleted_absence: "Demande d'absence retirée",
  new_request: "Nouvelle demande",
  your_requests: "Tes demandes",
  planned_days: "Jours planifiés",
  planned_hours: "Heures prévues",
  used_days: "Jours utilisés",
  used_hours: "Heures passées",
  free_days: "Jours de congé",
  free_hours: "Heures de vacances",
  open_days: "Journées ouvertes",
  open_hours: "Heures d’ouverture",
  withdraw_request: "Retirer la demande",
  change_request: "Modifier la demande",
  request_was_approved: "Ta demande a été approuvée",
  request_is_pending: "Ta demande n'a pas encore été approuvée",
  request_was_rejected: "Ta demande a été refusée",
  add_attachment: "Ajouter une annexe",
  message_optional: "Message (facultatif)",
  filed_on: "Déposé le",
  this_year: "Cette année",
  search_sub_projects: "Sur quel sous-projet aimerais-tu travailler ?",
  error_occurred: "Une erreur s’est produite, réessayez plus tard.",
  re_record: "Supprimer et réenregistrer cette vidéo ?",
  delete_video: "Supprimer l’enregistrement ?",
  no_results_found: "Aucun résultat trouvé",
  record_again: "Réessayer",
  request_valid_email: "Veuillez saisir une adresse e-mail valide.",
  request_valid_company_name: "Veuillez saisir un nom d'entreprise valide.",
  request_valid_first_name: "Veuillez saisir un prénom valide.",
  request_valid_last_name: "Veuillez saisir un nom de famille valide.",
  total_duration_today: "Temps total aujourd'hui",
  show_daily_protocol: "Afficher le journal quotidien",
  change_profile_pic: "Modifier la photo de profil",
  logout_account: "Déconnecter le compte",
  you_are_working: "Tu es en train de travailler !",
  you_are_taking_a_break: "Tu es en pause !",
  activity_edited: "Activité traitée",
  activity_edited_undo: "Traitement annulé avec succès",
  activity_edited_missing_project: "Oh, il manque encore le projet !",
  activity_deleted: "Activité supprimée",
  activity_deleted_undo: "Activité supprimée restaurée",
  activity_created: "Nouvelle activité créée",
  activity_created_undo: "Activité nouvellement créée retirée",
  correct_working_hours: "Corriger les temps de travail",
  your_changes_are_being_saved: "Tes modifications sont maintenant enregistrées.",
  manage_working_hours: "Gérer les temps de travail",
  delete_activity: "Supprimer une activité",
  start_navigation: "Démarrer la navigation",
  no_valid_email: "L'adresse e-mail saisie n'est pas valide.",
  delete_checklist: "Supprimer la liste de contrôle",
  active_checklists: "Listes de contrôle actives",
  scan_qr_code: "Scanner le code QR",
  switch_to_office_center: "Passer au centre de bureau",
  confirm_project_completion_short: "Clôturer le projet",
  confirm_project_date_completion_short: "Clôturer le rendez-vous",
  project_completed: "Projet terminé !",
  project_date_completed: "Rendez-vous terminé !",
  confirm_project_uncompletion_short: "Rouvrir le projet",
  confirm_project_date_uncompletion_short: "Réouverture du rendez-vous",
  project_uncompleted: "Projet activé",
  project_date_uncompleted: "Date activée",
  choose_project: "Sélectionner un projet",
  choose_sub_project: "Sélectionner un sous-projet",
  choose_site: "Choisir un site",
  active_projects: "Projets actifs",
  completed_term: "terminé",
  completed_projects: "Projets terminés",
  end_of_work: "Bonne fin de journée",
  correct_time: "Corriger l'heure",
  you_stamp_x: "Tu tamponnes",
  enter_pin: "Veuillez saisir votre code PIN",
  wrong_pin: "saisie incorrecte du code PIN",
  pin_change_required: "On t'a demandé de changer ton code PIN.",
  enter_new_pin: "Saisir un nouveau code PIN",
  approve_pin: "Confirmer le code PIN",
  no_projects_scheduled: "Pour {day} Aucun projet n’est stocké.",
  you_clock_in_project: "Tu saisis désormais des heures de travail de projet.",
  project_scan_error: "Ce code n’est valable pour aucun projet.",
  show_more_days: "afficher plus de jours",
  show_more_times: "Afficher plus de temps",
  only_show_today: "afficher aujourd'hui seulement",
  todays_total_time: "Temps total aujourd'hui",
  everything_synced: "Tes données sont à jour !",
  upload_in_progress: "Les données sont téléchargées...",
  who_are_you: "Qui êtes vous?",
  is_uploading_to_server: "Tes modifications sont en cours de transfert vers le centre de bureau.",
  offline_and_data_is_stored_locally: "Tes modifications seront bientôt transmises au centre de bureau. ",
  show_more: "en savoir plus",
  activity_edited_wrong_date: "Tu as saisi une date erronée.",
  confirm_logout: "Tu veux vraiment te désinscrire ?",
  confirm_clockout: "Tu es sûr de vouloir pointer pour aujourd'hui ?",
  gps_is_active: "Les données GPS sont transmises",
  location_tracking_is_active: "Pour permettre le suivi GPS.",
  app_settings: "Paramètres de l'application",
  clock_reminder: "Timpon - Rappel",
  mon_to_fri: "Standard : du lundi au vendredi",
  logout: "Déconnecter le compte",
  refresh: "Actualiser",
  prompt_language_settings: "Définis ici la langue de l'application.",
  prompt_clock_reminder: "Rappel via notification push pour correspondre à votre travail quotidien.",
  register_company: "Enregistrer une entreprise",
  use_code: "Utiliser le code",
  our_customers: "Nos clients",
  free_test_now: "Tester gratuitement maintenant",
  tier_attendance: "Je ne saisis que les heures de travail et les pauses.",
  tier_documentation: "Je souhaite également réserver des heures de travail sur des projets que je gère dans clockin.",
  your_tier: "Votre paquet",
  all_clockin_functions: "Toutes les fonctions clockin",
  checklists_formulars: "Listes de contrôle & fonctions",
  projectfile_incl_chat: "Dossiers de projet numériques (y compris le chat)",
  photo_sketch_note: "Fonction photo, croquis & notes",
  digital_signature: "Signatures numériques",
  datev_connection: "Connexion DATEV",
  calendar_absences: "Gérer le calendrier & les absences",
  individual_design: "Aspect individuel",
  attendance_time_tracking: "Saisie des temps stationnaire par terminal tablette",
  mobile_time_tracking: "Saisie mobile des temps par application smartphone",
  browser_time_tracking: "Saisie des temps par navigateur sur PC pour le bureau à domicile",
  help_use_code: "Veuillez saisir le code que vous trouverez dans le centre de bureau sous Appareils mobiles/employés.",
  wrong_code: "Code erroné",
  wrong_code_text: "Le code n'est pas valable. Veuillez réessayer avec un code valide",
  wrong_code_text_short: "Le code n'est pas valide",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Code QR non valide",
  invalid_qr_code_text: "Le code QR scanné n’est pas valide. Veuillez scanner un code d’horloge valide.",
  code_already_connected: "Ce code te permet de connecter ton appareil. Tu es cependant déjà connecté.",
  wrong_credentials: "Données d'accès incorrectes",
  wrong_credentials_text: "La combinaison e-mail/mot de passe que tu as saisie n'a pas pu être trouvée. Veuillez vérifier votre saisie et réessayer.",
  new_pin: "Saisir un nouveau code PIN",
  choose_next_action: "Choisis ta prochaine action",
  name_of_software_package: "Nom du progiciel",
  select_teamleader: "Qui poinçonne pour l'équipe ?",
  select_teamleader_description: "Pour continuer à pointer, choisis une personne qui s'occupera de l'appareil.",
  clocked_in_on_this_device: "Estampillé sur cet appareil",
  not_clocked_in_on_this_device: "Non estampillé sur cet appareil",
  select_new_teamleader: "Qui doit maintenant pointer pour l'équipe ?",
  switch_teamleader: "Transférer l'appareil",
  just_me: "Ne pointer que moi",
  select_the_new_teamleader: "Définir le nouveau chef d'équipe",
  back_to_selection: "retour à la sélection",
  manage_team: "Gérer une équipe",
  total_time_team: "Temps total de l'équipe",
  count_members_clocked_in: "{clockedin}/{members} membres de l'équipe estampillés",
  whole_team: "Toute l'équipe",
  teammembers_still_clockedin: "Choisis si tu veux pointer seulement toi ou tous les membres de l'équipe ?",
  clockout_all: "Poinçonner tout",
  select_employee: "Choisis d'abord un utilisateur",
  something_went_wrong: "Quelque chose s'est mal passé, veuillez réessayer plus tard.",
  new_pin_successfully_changed: "Code PIN modifié avec succès",
  enter_pin_before_clockin_prompt: "Saisissez d'abord votre code PIN individuellement pour vous faire tamponner.",
  enter_pin_before_clockout_prompt: "Saisissez d'abord votre code PIN pour vous faire tamponner.",
  delete_activity_alert_title: "Supprimer une activité",
  delete_activity_alert_msg: "Es-tu sûr de vouloir supprimer l'activité ?",
  delete_absence_message: "Es-tu sûr de vouloir retirer ta demande ?",
  delete_absence_title: "Retirer la demande",
  are_you_sure: "Tu en es sûr ?",
  request_password: "Demander un nouveau mot de passe",
  password_requested: "Un lien pour un nouveau mot de passe a été envoyé à ton adresse e-mail.",
  no_email_retrieved: "Tu n'as pas reçu de mail ? Vérifie ton dossier spam ou réessaie.",
  name_of_customer: "Nom du client",
  missing_permissions_homepage_text: "Tu n'as pas l'autorisation de changer d'activité sur cet appareil. Veuillez contacter votre administrateur pour obtenir l'accès.",
  no_permission_warning_my_area: "Tu n'as pas l'autorisation d'accéder à cette section. Veuillez contacter votre administrateur pour obtenir l'accès.",
  employee_clocked_in: "{name} inscrits !",
  employee_clocked_out: "{name} déconnecté !",
  no_employee_to_qr_code_warning: "Aucun collaborateur n'a pu être trouvé pour ce code QR.",
  no_employees_registered_heading: "Aucun employé n'a encore été affecté à cet appareil.",
  no_employees_registered_body: "Dans le centre de bureau, dans les paramètres de l'appareil mobile, tu peux attribuer des collaborateurs qui pourront ensuite saisir leurs temps sur cet appareil.",
  no_employee_found: "Malheureusement, personne n'a pu être trouvé avec ce nom.",
  no_employee_assigned: "Aucun employé assigné",
  you_need_help: "Tu as besoin d'aide ?",
  here_you_can_get_help_to_register_employees_for_device: "Tu trouveras ici toutes les informations sur la manière d'attribuer des collaborateurs à un appareil.",
  show_time: "Créer du temps",
  export_timesheet: "Exporter la feuille de temps",
  select_month: "Choisir le mois",
  internet_connection_required: "Pour cela, une connexion Internet est nécessaire.",
  select_an_activity_to_clockin_your_team: "Choisis une activité pour marquer ton équipe.",
  confirm_uploading_sqlite_for_debugging: "Es-tu sûr de vouloir télécharger les données dans l'application pour l'assistance Clockin ?",
  no_tasks_available: "Aucune tâche disponible",
  click_to_add_tasks: "Cliquez pour ajouter des tâches",
  scan_nfc_tag: "Veuillez tenir votre carte devant le lecteur.",
  link_nfc_tag: "Lien : Balise NFC",
  select_employee_for_nfc_tag: "Veuillez sélectionner un employé pour lier cette balise NFC :",
  nfc_tag_linked_successfully: "Balise NFC avec succès avec {name} lié.",
  nfc_linking_failed: "La balise NFC n’a pas pu être liée. Veuillez réessayer.",
  nfc_not_enabled: "La technologie NFC n’est pas prise en charge par cet appareil ou est désactivée.",
  nfc_initialization_failed: "Malheureusement, quelque chose a mal tourné. Veuillez réessayer.",
  nfc_scan_failed: "Malheureusement, quelque chose a mal tourné. Veuillez réessayer.",
  nfc_no_tag_found: "Aucune balise NFC n’a été trouvée.",
  nfc_tag_already_linked_to: "Cette balise NFC est déjà disponible avec {name} lié.",
  nfc_scan_active: "Analyse NFC active",
  nfc_linking_enabled: "Les tags NFC peuvent désormais être liés. Veuillez maintenant tenir la balise NFC pour être liée au lecteur NFC.",
  nfc_all_employees_linked: "Tous les employés affectés à cet appareil ont déjà été liés.",
  no_employee_to_nfc_warning: "Aucun employé n’a pu être trouvé pour cette étiquette NFC.",
  select_employee_to_link_nfc: "À qui la balise NFC doit-elle être liée ?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Bienvenue sur Clockin",
        clocking_time: "Temps sur piste",
        push_notifications: "N’oublie rien"
      },
      text: {
        clocking_time: "Le chronomètre est votre point de départ pour chaque activité. Vous vous occupez de votre travail, l’application s’occupe de la documentation.",
        push_notifications: "Maintenant, activez les notifications. Clockin vous rappelle si vous oubliez un timbre et s’assure que vous recevez tout ce qui est important immédiatement."
      },
      button: {
        lets_go: "Démarrer maintenant"
      }
    },
    my_area: {
      heading: {
        my_area: "Mon domaine",
        absences: "Absences et demandes",
        settings: "Paramètres personnels"
      },
      text: {
        my_area: "L'endroit central où tu peux voir immédiatement tes heures de travail et tes heures supplémentaires. À partir de là, tu peux gérer tes heures de travail, accéder à ton journal quotidien, déposer des demandes et consulter tes horaires.",
        absences: "Gère les demandes de congé, les jours de maladie et autres absences. Garde toujours un œil sur le statut de tes demandes et soumets de nouvelles demandes facilement et rapidement en quelques clics.",
        settings: "Envoie des messages dans l'entreprise ou modifie tes paramètres personnels et si tu veux changer ton mot de passe, c'est aussi possible ici !"
      },
      button: {
        lets_go: "Commencez"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Parce que ton temps compte",
        clock_in: "Tamponner",
        switch_task: "Changement de cachet",
        clock_out: "Pointage",
        thats_it: "C'est tout !"
      },
      text: {
        your_time_matters: "Avec clockin, nous t'aidons à te concentrer sur l'essentiel. Saisis ton temps de travail en un seul clic.",
        clock_in: "En un clic, tu es directement horodaté. Clockin enregistre automatiquement tes données et tu as tout sous les yeux à tout moment.",
        switch_task: "Tu as un autre projet, tu fais une pause ou tu te rends à ton prochain rendez-vous ? Tamponne simplement ta nouvelle activité. Le reste est enregistré automatiquement.",
        clock_out: "Et en un clic, tu es tamponné.",
        thats_it: "Tu as réussi et tu es prêt à saisir ton temps de travail. Si tu as besoin d'aide, il te suffit de nous contacter. Chez clockin, tout est simple - même la communication avec nous."
      },
      button: {
        your_time_matters: "Montre-moi comment ça marche",
        thats_it: "Démarrer maintenant"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Parce que ton temps compte",
        clock_in: "Tamponner",
        clock_in_team: "Pointer l'équipe",
        switch_task: "Changement de cachet",
        change_teamleader: "Transférer l'appareil",
        clock_out: "Pointage",
        thats_it: "C'est tout !"
      },
      text: {
        your_time_matters: "Avec clockin, nous t'aidons à te concentrer sur l'essentiel. Saisis le temps de travail de ton équipe en un seul clic.",
        clock_in: "Choisis une personne qui pointera pour l'équipe et en un clic, tu seras directement pointé. clockin enregistre automatiquement tes données et tu as tout sous les yeux à tout moment.",
        clock_in_team: "Tamponne directement ton équipe en toute simplicité. Que ce soit tous en même temps ou seulement certains membres.",
        switch_task: "Vous avez un autre projet, vous faites une pause ou vous vous rendez à votre prochain rendez-vous ? Tamponnez simplement sur votre nouvelle activité. Le reste sera automatiquement saisi.",
        change_teamleader: "Tu finis ta journée, tu dois partir ou tu ne pointes plus pour l'équipe ? Il te suffit de transférer l'appareil dans l'application et tout reprend son cours normal.",
        clock_out: "Et en un clic, toi et ton équipe êtes estampillés. Bien sûr, tu peux aussi à tout moment dépointer des membres individuels.",
        thats_it: "Tu as réussi et tu es prêt à saisir le temps de travail de ton équipe. Si tu as besoin d'aide, n'hésite pas à nous contacter. Chez clockin, tout est simple - même la communication avec nous."
      },
      button: {
        your_time_matters: "Montre-moi comment ça marche",
        thats_it: "Démarrer maintenant"
      }
    },
    my_area: {
      heading: {
        welcome: "Bienvenue dans ton domaine",
        my_area: "Mon domaine",
        create_time: "Créer du temps",
        change_time: "Corriger l'heure",
        absences: "Absences et demandes",
        settings: "Paramètres personnels",
        thats_it: "C'est tout !"
      },
      text: {
        welcome: "Découvre maintenant encore plus de possibilités pour gérer ton temps de travail de manière efficace et simple. Jetons un coup d'œil à ton domaine.",
        my_area: "L'endroit central où tu peux voir immédiatement tes heures de travail et tes heures supplémentaires. À partir de là, tu peux gérer tes heures de travail, accéder à ton journal quotidien, déposer des demandes et consulter tes horaires.",
        create_time: "Tu as oublié de saisir un temps ou tu souhaites ajouter des temps ultérieurement ? Pas de problème ! Ajoute les temps manquants, saisis les pauses et garde ton compte de temps de travail toujours à jour.",
        change_time: "Tu veux corriger tes temps ? Pas de problème ! Avec clockin, tu peux facilement corriger et adapter des temps erronés.",
        absences: "Gère les demandes de congé, les jours de maladie et autres absences. Garde toujours un œil sur le statut de tes demandes et soumets de nouvelles demandes facilement et rapidement en quelques clics.",
        settings: "Envoie des messages dans l'entreprise ou modifie tes paramètres personnels et si tu veux changer ton mot de passe, c'est aussi possible ici !",
        thats_it: "C'est fait ! Tu peux maintenant gérer tes horaires sans effort, organiser tes absences et te concentrer sur l'essentiel : ton travail. Bonne chance dans ton temps productif !"
      },
      button: {
        welcome: "Montre-moi comment ça marche",
        thats_it: "Démarrer maintenant"
      }
    },
    clock: {
      clockin_now: "Cliqueter maintenant",
      clock_your_first_time_now: "& saisir ta première fois"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Merci d'utiliser clockin !",
      question: "Quelle est la probabilité que tu recommandes clockin à tes amis ou collègues ?",
      very_likely: "Très probable",
      very_unlikely: "Très peu probable",
      help_us_improve: "Comment pouvons-nous améliorer clockin pour toi ?",
      what_do_you_agree_with: "Avec quelles affirmations serais-tu d'accord ?",
      choose_three_statements: "Choisis jusqu'à trois affirmations.",
      hard_to_use: "difficile à utiliser",
      lacking_features: "trop peu de fonctions",
      does_not_help_me: "ne facilite pas mon travail quotidien",
      confusing: "peu clair",
      poorly_implemented: "Fonctions mal mises en œuvre",
      too_buggy: "trop sujet aux erreurs",
      too_slow: "temps de chargement long",
      what_else: "As-tu quelque chose d'autre à nous dire ?",
      can_we_ask_you_a_few_questions: "Pouvons-nous te poser quelques questions supplémentaires ?",
      how_happy_are_you_with_the_introduction_of_clockin: "À quel point es-tu heureux de l'introduction de clockin dans ton entreprise ?",
      how_much_do_you_enjoy_using_clockin: "A quel point aimes-tu utiliser clockin ?",
      how_much_easier_does_clockin_make_your_work: "Dans quelle mesure clockin facilite-t-il ton travail quotidien ?",
      how_happy_are_you_with_the_following_aspects: "Dans quelle mesure es-tu satisfait(e) des points suivants ?",
      clarity_of_the_app: "Clarté de l'application",
      simplicity_of_use: "Simplicité d'utilisation",
      app_features: "Fonctionnalités de l'application",
      feedback_received: "Ton feedback est bien arrivé. Merci d'avoir pris le temps de le faire.",
      thanks_for_taking_the_time: "Merci d'avoir pris le temps de le faire.",
      what_can_we_do_to_improve: "Peux-tu nous en dire plus sur ton expérience afin que nous puissions faire encore mieux la prochaine fois ?",
      what_can_we_do_to_get_it_right: "Peux-tu nous en dire plus sur ton expérience afin que nous puissions faire les choses correctement la prochaine fois ?",
      comment_placeholder: "Ton message"
    }
  },
  travel_logs: {
    add: "Ajouter des détails sur le trajet",
    edit: "Modifier les détails du trajet",
    saving: "Les détails du trajet sont enregistrés...",
    saved_successfully: "Détails du trajet enregistrés avec succès !",
    unable_to_save: "Malheureusement, cela n'a pas fonctionné 😢"
  },
  attach_file: "Joindre un fichier",
  image_to_text: {
    info: "Veille à ce que le texte soit bien visible et qu'il apparaisse entièrement sur l'image.",
    attach_image: "Joindre une image",
    processing: "Ton texte est lu.",
    processing_failed: "Malheureusement, la lecture n'a pas fonctionné 😢",
    no_text_found: "Aucun texte n'a pu être reconnu."
  },
  correction_enter_reason: "Veuillez fournir une raison pour la correction.",
  daily_notes: {
    add: "Écrire une note",
    edit: "Modifier une note",
    saving: "La note est enregistrée...",
    saved_successfully: "Note enregistrée avec succès !",
    unable_to_save: "Malheureusement, cela n'a pas fonctionné 😢",
    no_notes_yet: "Aucune note créée",
    create_note: "Créer"
  },
  calendar_sync: {
    title: "Synchroniser la planification",
    description: "Synchronise ton plan d'action avec un calendrier et garde un œil sur les anciens et les nouveaux rendez-vous.",
    url: "Adresse au format iCal",
    url_description: "Cette adresse te permet d'accéder à ce calendrier à partir d'autres applications.",
    note: "Remarque",
    note_description: "Pour certains calendriers, il peut s'écouler jusqu'à 24 heures avant que les nouveaux rendez-vous ne s'y affichent.",
    sync_now: "Synchroniser le calendrier",
    copied: "URL du calendrier copiée."
  },
  registration: {
    skip_all: "Sauter tout",
    already_signed_up: "J'ai déjà un compte",
    title_1: "Commençons à travailler ! Quels sont les temps que tu souhaites saisir avec clockin ?",
    description_1: "Laisse-nous adapter clockin à toi",
    option_1_a: "Temps de travail général (arrivée, départ & pause)",
    option_1_b: "Horaires de travail du projet",
    title_2: "Tu veux te documenter ?",
    description_2: "Quelles exigences doivent être remplies pour cela ?",
    option_2_a: "Photos",
    option_2_b: "Esquisses",
    option_2_c: "Fonction de prise de notes",
    option_2_d: "Listes de contrôle & formulaires",
    option_2_e: "Dossiers de projets numériques",
    title_3: "Que veux-tu encore numériser ?",
    description_3: "Il y a encore beaucoup d'autres choses à découvrir chez clockin, peut-être y a-t-il quelque chose pour toi.",
    option_3_a: "Vacances",
    option_3_b: "Maladies & absences",
    option_3_c: "Dossier personnel numérique",
    option_3_d: "Analyse de l'entreprise",
    option_3_e: "Planification de l'intervention",
    option_3_f: "Transmission des données du conseiller fiscal (DATEV)",
    title_4: "Dans quel secteur d'activité se trouve ton entreprise ?",
    description_4: "Nous voulons mieux te connaître afin d'adapter clockin davantage à tes besoins.",
    option_4_a: "Services",
    option_4_b: "Artisanat",
    option_4_c: "Santé et bien-être",
    option_4_d: "Achat, commande & commerce",
    option_4_e: "Hôtellerie et restauration",
    option_4_f: "Auto, trafic & machines",
    option_4_g: "Autre secteur",
    title_5: "Combien d'employés font partie de ton entreprise ?",
    description_5: "Avec le nombre de collaborateurs, nous pouvons adapter clockin à la taille de ton entreprise.",
    title_6: "Super ! Ton clockin est en cours de configuration",
    description_6: "Il ne nous manque plus que ton nom.",
    input_6_a: "Société",
    input_6_b: "Prénom",
    input_6_c: "Nom de famille",
    input_6_d: "Numéro de téléphone",
    title_7: "C'est parti ! Teste clockin gratuitement pendant 14 jours !",
    input_7_a: "Ton adresse e-mail",
    description_7: "À quelle adresse e-mail devrions-nous t'envoyer ton mot de passe ?",
    input_7_b: "C'est ainsi que je suis devenu attentif",
    how_did_you_hear_about_clockin: "Comment as-tu entendu parler de clockin pour la première fois ?",
    recommendation_option_1: "Recommandation",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Recherche sur Internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Plate-forme de comparaison",
    recommendation_option_7: "Magazine & articles en ligne",
    known_from: "Connu de",
    agb_1: "En envoyant ce formulaire, tu acceptes les ",
    agb_2: "CONDITIONS GÉNÉRALES DE VENTE",
    agb_3: " et les ",
    agb_4: "Déclaration de confidentialité",
    start: "Démarrer le test",
    validation_failed: "Remplis correctement tous les champs."
  },
  clocki: {
    listening_heading: "Je vous écoute",
    listening_subtext: "Comment puis-je vous aider?",
    hi_0: "Bonjour, comment puis-je t'aider ?",
    hi_1: "Hé, comment puis-je t'aider ?",
    hi_2: "Bonjour, comment puis-je vous aider ?",
    hi_3: "Moin moin, que puis-je faire pour toi ?",
    hi_4: "Salut, que puis-je faire pour toi ?",
    hi_5: "Bonjour, comment puis-je t'aider ?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Malheureusement, la reconnaissance vocale ne semble pas fonctionner sur ton appareil",
    microphone_permission_denied: "Malheureusement, je n'ai pas accès à ton microphone. Merci de vérifier les autorisations dans les paramètres afin que je puisse t'entendre.",
    please_speak: "Tu peux maintenant parler à Clocki",
    create_activity: "Créer une activité",
    modify_activity: "Activité de changement",
    delete_activity: "Supprimer l’activité",
    create_daily_note: "Créer une note quotidienne",
    search_project: "Rechercher un projet",
    note_copied: "Note copiée",
    create_absence_request: "Demander une absence",
    delete_absence: "Supprimer une absence",
    confirm_deletion: "Êtes-vous sûr que votre {activity_label} Estampage à partir de {date} l’horloge devrait être supprimée ?",
    confirm_absence_deletion: "Êtes-vous sûr que votre demande de {category} de la {startDate} jusqu’à {endDate} Vous souhaitez supprimer ?",
    task_before_modification: "Avant: {task}",
    starts_at_before_modification: "Heure de début avant : {startsAt}",
    ends_at_before_modification: "Heure de fin avant : {endsAt}",
    something_went_wrong: "Oh, quelque chose s'est mal passé, veuillez réessayer plus tard.",
    was_this_helpful: "Clocki pourrait-il vous aider ?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confirmer l'absence"
      },
      CREATE_DAILY_NOTE: {
        title: "Créer une note maintenant",
        daily_notes_disabled: "Malheureusement, la fonction de prise de notes est désactivée. Demande à ton administrateur d'activer cette fonction dans le centre de bureau.",
        success: "Note enregistrée avec succès dans le journal quotidien 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Créer une documentation maintenant",
        created_by_clocki: "Créé avec Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Ouvrir maintenant \"Mes temps\"."
      },
      REDIRECT_TO_MY_AREA: {
        title: "Ouvrir maintenant \"Mon espace\"."
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Ouvrir maintenant \"Modifier le mot de passe"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Tamponner maintenant \"temps de travail",
        PAUSE: "Tamponner \"pause\" maintenant",
        DRIVING_TIME: "Poinçonnez maintenant le \"temps de trajet\".",
        LOGOUT: "Décliqueter maintenant"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Aimez-vous utiliser Clockin ?"
  },
  translation_failed: "Malheureusement, la traduction n’a pas fonctionné 😕",
  video_transcript_not_available: "Aucune transcription disponible",
  video_upload_succeeded: "Téléchargement vidéo terminé.",
  video_upload_failed: "Téléchargement vidéo échoué.",
  video_send_failed: "La vidéo n’a pas pu être diffusée pour le moment. On essaiera encore plus tard.",
  uploading_video: "Téléchargement de vidéo...",
  language_selection_header: "Sélectionner une langue",
  language_selection_message: "Choisissez votre langue préférée",
  shifts: {
    my_shifts: "Mes Shifts",
    free_shifts: "Shifts libres",
    next_shift: "Ton prochain service",
    shift_not_found: "Aucune couche trouvée",
    show_shift_plan: "Consultez cet horaire de quarts",
    no_shift_place: "Aucun lieu précisé",
    no_shifts_assigned: "Vous n’êtes actuellement affecté à aucun service",
    free_shifts_unavailable: "Les horaires libres ne sont actuellement pas disponibles",
    filter_shift_plans: "Plannings de quarts de filtre",
    no_shift_plans_available: "Aucun horaire de travail disponible n’est disponible",
    filter_locations: "Lieux de filtrage",
    no_locations_available: "Aucune place disponible",
    no_plan_selected: "Aucun horaire de service sélectionné",
    no_shifts_for_plan: "Aucune couche trouvée pour ce plan",
    no_shifts_for_location: "Aucun changement trouvé pour l’emplacement sélectionné",
    unknown_shift_plan: "Horaire de quart inconnu",
    unknown_location: "Emplacement inconnu",
    loading_more_shifts: "Chargez plus de couches..."
  },
  clockin_reminder_title: "Déjà au travail ? 🔔",
  clockin_reminder: "N’oubliez pas de pointer l’entrée.",
  clockout_reminder_title: "Tu es déjà à la fin de la journée ? 🔔",
  clockout_reminder: "N’oublie pas de pointer ta sortie.",
  choose_clockin_reminder_time: "Heure du rappel d’arrivée",
  choose_clockout_reminder_time: "Heure du rappel de pointage",
  choose_break_reminder_time: "Durée de la pause",
  saved_successfully: "Sauvegardé 👍 avec succès",
  clock_reminder_channel_name: "Rappels de timbres",
  clock_reminder_channel_description: "Rappels pour pointer à l’entrée et à la sortie",
  break_reminder_title: "Tu fais encore une pause ? ⏰",
  break_reminder: "Note : Votre temps de pause est toujours écoulé.",
  // Video component translations
  video_not_supported: "Votre appareil ne prend pas en charge la vidéo :/",
  video_loading_error: "Vidéo de chargement d’erreur",
  video_retry: "Rechargement"
};